<template>
  <div class="loader-container">
    <div class="loader">
      <div class="loader-ring"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss" scoped>
.loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: $secondary-gradient;
  z-index: 9999;
}

.loader {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.loader-ring {
  position: absolute;
  width: 60px;
  height: 60px;
  border: 3px solid transparent;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;

  &:nth-child(1) {
    border-top-color: $neutral-60;
    animation-delay: 0s;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


// Адаптивность для мобильных устройств
@media (max-width: 768px) {
  .loader-ring {
    &:nth-child(1) {
      width: 40px;
      height: 40px;
    }

    &:nth-child(2) {
      width: 60px;
      height: 60px;
    }

    &:nth-child(3) {
      width: 80px;
      height: 80px;
    }
  }

  .loader-text {
    margin-top: 50px;
    font-size: 14px;
  }
}
</style>
